import { hiddenQyWxShareOption, hiddenWxShareOption } from '../../utils';
import { HostEnv } from '@shared/types';
import { useHostEnv } from '../use-host-env';

// 隐藏分享选项
export const initHiddenShareOption = async () => {
  const { currentHostEnv } = useHostEnv();

  if (import.meta.env.VITE_WX_JS_SDK_ENABLED === 'on') {
    switch (currentHostEnv) {
      case HostEnv.QYWX:
        await hiddenQyWxShareOption();
        break;
      case HostEnv.WX:
        await hiddenWxShareOption();
        break;
      default:
        break;
    }
  }
};
